import type { FolderNode } from '../../types/fileSystem.js';

export const getFolderIcon = (folderData: FolderNode) => {
  if (folderData.isPrivate) return 'private';
  if (folderData.isBucket) return 'shared';

  return 'folder';
};
